import {createContext, useContext} from 'react';

export interface ISiteInfo {
  url: string;
  baseUrl: string;
}

export const SiteInfoContext = createContext<ISiteInfo | undefined>(undefined);

export const useSiteInfo = () => {
  return useContext(SiteInfoContext);
};
